import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from 'react-stripe-elements';
import BuyAddonsContainer from 'modules/payment/containers/BuyAddonsContainer';

const PaymentPage = ({ cottage, submitCommission, submitCommissionAndAskForReview }) => (
  <div>
    <Elements>
      <BuyAddonsContainer
        cottage={cottage}
        submitCommission={submitCommission}
        submitCommissionAndAskForReview={submitCommissionAndAskForReview}
      />
    </Elements>
  </div>
);

PaymentPage.propTypes = {
  cottage: PropTypes.shape({}),
  submitCommission: PropTypes.func.isRequired,
  submitCommissionAndAskForReview: PropTypes.func.isRequired,
};

export default PaymentPage;
